import { FcmNotification } from './libs/fcmNotification'
import { Events } from './events'
import { SocketsNotifications } from './libs/sockets'
import { QuickStorage } from './quickStorage'

class NotificationUtils {
  static async init() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return
    NotificationUtils.initAllowedNotifsTypes()
    NotificationUtils.initIframeFunctions()

    Events.handleEvent('notification_permission_accepted', requestDeviceToken)
    Events.handleEvent('login_done', requestDeviceToken)
    Events.handleEvent('registration_done', requestDeviceToken)

    if (window.useFcmNotif && notificationApiAvailable())
      NotificationUtils.initFcmNotification()
    if (window.useSocketNotif || !notificationApiAvailable())
      NotificationUtils.initSocketNotification()
    window.onNotificationReceived = onNotificationReceived
  }

  static initIframeFunctions() {
    if (!window.isIframe) return
    Events.handleEvent('iframe_notification_received', onNotificationReceived)
    window.requestNotificationPermission = async () => {
      const timeout = 999999999
      const res = await Events.sendDataRequestResolve(
        'requestNotificationPermission',
        {},
        timeout,
      )
      return res?.permission || ''
    }
    window.showNotification = async (title, body, id) => {
      Events.dispatchEvent('showNotification', {
        title,
        body,
        id: '',
      })
    }
    window.getNotificationDeviceToken = async () => {
      const timeout = 999999999
      const res = await Events.sendDataRequestResolve(
        'deviceToken',
        {},
        timeout,
      )
      return { success: !!res?.deviceToken, token: res?.deviceToken || '' }
    }
  }

  static initAllowedNotifsTypes() {
    window.useFcmNotif = false
    window.useSocketNotif = true
  }

  static initFcmNotification() {
    Events.handleEvent(
      'request_notification_permission',
      requestNotificationPermissionInternal,
    )
    try {
      FcmNotification.init()
      FcmNotification.setNotificationHandler(onFcmNotification)
    } catch (error) {
      console.log(error)
    }
    requestDeviceToken()
  }

  static initSocketNotification() {
    Events.handleEvent(
      'login_done',
      SocketsNotifications.initUserTokenConnection,
    )
    Events.handleEvent(
      'registration_done',
      SocketsNotifications.initUserTokenConnection,
    )
    SocketsNotifications.init()
    SocketsNotifications.setNotificationHandler(onSocketNotification)
    requestDeviceToken()
  }

  static canAcceptNotification() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return false
    return window.useFcmNotif && notificationApiAvailable()
  }

  static notificationPermissionIsAccepted() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return false
    if (!window.useFcmNotif || !notificationApiAvailable()) return false
    return notificationPermissionIsAccepted()
  }
}

function notificationApiAvailable() {
  let isClient = false
  try {
    if (window) isClient = true
  } catch (error) {
    console.log(error)
  }
  if (!isClient) return false
  if (window.requestNotificationPermission) return true
  if (window.isIframe) return true
  if ('Notification' in window) return true
  return false
}

function onFcmNotification(rawNotification) {
  console.log(rawNotification)
  Events.dispatchEvent('received_forground_fcm_notification', rawNotification)
}

function onSocketNotification(rawNotification) {
  console.log(rawNotification)
  Events.dispatchEvent('received_socket_notification', rawNotification)
}

function onNotificationReceived(rawNotification) {
  Events.dispatchEvent('received_notification', rawNotification)
  return { handled: true }
}

async function requestDeviceToken() {
  if (window.useSocketNotif || !notificationApiAvailable()) {
    const deviceToken = await SocketsNotifications.getToken()
    Events.dispatchEvent('device_token_available', { deviceToken })
  }
  if (window.useFcmNotif && notificationApiAvailable()) {
    const deviceToken = await getFcmDeviceToken()
    Events.dispatchEvent('device_token_available', { deviceToken })
  }
}

async function getFcmDeviceToken() {
  let isClient = false
  try {
    if (window) isClient = true
  } catch (error) {
    console.log(error)
  }
  if (!isClient) return
  let accepted = notificationPermissionIsAccepted()
  if (!accepted) return ''
  if (window.getNotificationDeviceToken) {
    const response = await window.getNotificationDeviceToken()
    if (!response.success) return ''
    return response.token
  }
  return FcmNotification.getDeviceToken()
}

function notificationPermissionIsAccepted() {
  try {
    return Notification.permission == 'granted'
  } catch (error) {
    const notificationPermission = QuickStorage.getStored(
      'notificationPermission',
    )
    return notificationPermission == 'granted'
  }
}

async function requestNotificationPermissionInternal() {
  console.log('requesting permission')
  let permission
  if (window.requestNotificationPermission) {
    permission = await window
      .requestNotificationPermission()
      .then(res => {
        return 'granted'
      })
      .catch(res => {
        console.log(res)
        return 'denied'
      })
    QuickStorage.storeData('notificationPermission', permission)
  } else {
    permission = await Notification.requestPermission()
  }
  if (permission == 'granted')
    return Events.dispatchEvent('notification_permission_accepted')
  if (permission == 'denied')
    return Events.dispatchEvent('notification_permission_denied')
  return Events.dispatchEvent('notification_permission_set_to_default')
}

export { NotificationUtils }
